import DateRangePicker, { DateSelection } from '@/components/base/DateRangePicker/DateRangePicker';
import { Period } from '@/types/date';
import { FC, RefObject } from 'react';
import { createPortal } from 'react-dom';
import styles from './DateRangeInput.module.css';

interface PickerPosition {
  top: number;
  left: number;
}

interface DateRangePickerPortalProps {
  showDatePicker: boolean;
  currentValue: Period | undefined;
  pickerRef: RefObject<HTMLDivElement | null>;
  pickerPosition: PickerPosition;
  handleCloseDatePicker: () => void;
  handleAcceptDateRange: (period: Period) => void;
  onDateSelectionChange?: (selection: DateSelection) => void;
  onClear?: () => void;
}

const DateRangePickerPortal: FC<DateRangePickerPortalProps> = ({
  showDatePicker,
  currentValue,
  pickerRef,
  pickerPosition,
  handleCloseDatePicker,
  handleAcceptDateRange,
  onDateSelectionChange,
  onClear,
}) => {
  if (!showDatePicker || (pickerPosition.top === 0 && pickerPosition.left === 0)) {
    return null;
  }

  return createPortal(
    <div
      ref={pickerRef}
      className={styles.datePickerPortal}
      data-floating-portal
      style={{
        top: pickerPosition.top,
        left: pickerPosition.left,
      }}
    >
      <DateRangePicker
        handleCloseDatePicker={handleCloseDatePicker}
        handleAcceptDateRange={handleAcceptDateRange}
        onDateSelectionChange={onDateSelectionChange}
        onClear={onClear}
        value={currentValue}
      />
    </div>,
    document.body,
  );
};

export default DateRangePickerPortal;

export type { DateSelection };
